export const SET_IS_LOADING = 'STATIC_PEN::SET_IS_LOADING';

export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    };
}

export const OPEN_LEGEND = 'STATIC_PEN::OPEN_LEGEND';

export function openLegend() {
    return {
        type: OPEN_LEGEND,
    };
}

export const CLOSE_LEGEND = 'STATIC_PEN::CLOSE_LEGEND';

export function closeLegend() {
    return {
        type: CLOSE_LEGEND,
    };
}

export const SET_PEN = 'STATIC_PEN::SET_PEN';

export function setPen(pen) {
    return {
        type: SET_PEN,
        pen,
    };
}
